import { render, staticRenderFns } from "./cardProduct.vue?vue&type=template&id=398122df&"
import script from "./cardProduct.vue?vue&type=script&lang=js&"
export * from "./cardProduct.vue?vue&type=script&lang=js&"
import style0 from "./cardProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports